export const getTheme = (product) => {
  const colors = {
    "immersi-learn": {
      primary: "#02a90a",
      sceneInfoBgColor: "rgba(2, 169, 10, 0.895)",
      breadcrumbsColor: "#04ce0d",
      mainPageBgImage: "/images/main-menu/immersi.jpg",
    },
    xrlab360: {
      primary: "#eeb820",
      sceneInfoBgColor: "rgba(238,184,33, 0.895)",
      breadcrumbsColor: "#efc345",
      mainPageBgImage: "/images/main-menu/xr_lab_360.jpg",
    },
    thenextgenxr: {
      primary: "#0c8ade",
      sceneInfoBgColor: "rgba(12,138 , 222, 0.895)",
      breadcrumbsColor: "#0099ff",
      mainPageBgImage: "/images/main-menu/the_next_gen.jpg",
    },
    virtupaths: {
      primary: "#673AB7",
      sceneInfoBgColor: "rgba(103, 58, 183, 0.895)",
      breadcrumbsColor: "#8959e0",
      mainPageBgImage: "/images/main-menu/virtual_path.jpg",
    },
  };
  const theme = colors[product];

  return theme;
};
